import React from "react";

const Terms = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mt-2 mb-6">
              Terms
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          {/* Effective Date */}
          <p className="font-semibold text-gray-800">
            Effective Date: 01 Jan 2026
          </p>

          <p className="text-gray-700 leading-relaxed">
            Welcome to{" "}
            <span className="text-[#b32126] font-semibold">
              Infotech.works.{" "}
            </span>
            By accessing or using our website, you agree to be bound by the
            following terms and conditions. If you do not agree, please refrain
            from using our website.
          </p>

          <hr className="border-gray-300" />

          {/* Section 1 */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>1. Ownership and Intellectual Property</strong>
            </h2>

            <p className="text-gray-700">
              All content on this website—including text, graphics, images,
              logos, code, and software—is the property of {""}
              <strong>ITWorks Infotech Pvt. Ltd.</strong>, its affiliates, or
              licensors and is protected by Indian intellectual property laws
              and applicable international treaties.
            </p>

            <p>
              No content may be copied, reproduced, republished, uploaded,
              posted, transmitted, or distributed in any form without prior
              written permission from ITWorks Infotech Pvt. Ltd.
            </p>
          </div>
          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>2. Use of the Website</strong>
            </h2>

            <p className="text-gray-700">
              You may access and use this website solely for lawful purposes and
              for informational use related to our services. You agree not to:
            </p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                Engage in any activity that disrupts or interferes with the
                website
              </li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use the website for fraudulent or malicious purposes</li>
              <li>
                VMisrepresent your identity or affiliation with any person or
                organization
              </li>
            </ul>
            <p>
              Infotech.works reserves the right to restrict or terminate your
              access at any time if these terms are violated.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>3. Disclaimers</strong>
            </h2>

            <p className="text-gray-700">
              The information provided on this website is for general
              information purposes only. While we strive to keep the content up
              to date and accurate, <strong>Infotech.works</strong> makes no
              warranties or representations regarding the accuracy,
              completeness, or reliability of any information or materials.
            </p>

            <p className="text-gray-700">
              All content is provided “as is” without warranties of any kind,
              either express or implied.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>4. Limitation of Liability</strong>
            </h2>

            <p className="text-gray-700">
              To the fullest extent permitted by applicable law, Infotech.works
              shall not be liable for any damages arising from:
            </p>

            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Use of or inability to use this website</li>
              <li>Errors, omissions, or inaccuracies in website content</li>
              <li>Unauthorised access to or alteration of your data</li>
            </ul>
            <p className="text-gray-700">
              This includes direct, indirect, incidental, punitive, and
              consequential damages.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>5. Links to Third-Party Sites</strong>
            </h2>

            <p className="text-gray-700">
              This website may contain links to third-party websites or tools.
              These are provided for convenience only, and Infotech.works does
              not endorse or assume any responsibility for their content,
              policies, or practices.
            </p>

            <p className="text-gray-700">
              Use of such third-party sites is at your own risk.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>6. Privacy</strong>
            </h2>

            <p className="text-gray-700">
              Use of this website is also governed by our Privacy Notice, which
              outlines how we collect, use, and protect your personal data.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>7. Governing Law and Jurisdiction</strong>
            </h2>

            <p className="text-gray-700">
              These terms are governed by and construed in accordance with the
              laws of <strong>India</strong>. Any disputes arising in connection
              with these terms shall be subject to the exclusive jurisdiction of
              the courts of <strong>Pune, Maharashtra</strong>.
            </p>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>8. Changes to Terms</strong>
            </h2>

            <p className="text-gray-700">
              Infotech.works may update these Terms and Conditions at any time
              without notice. Continued use of the website after changes are
              posted constitutes your acceptance of the revised terms.
            </p>
          </div>
          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>9. Contact Us</strong>
            </h2>
            <p className="text-gray-700">
              If you have questions, requests, or grievances regarding your
              personal data:
            </p>
            <p>
              📧 {""}
              <a
                href="mailto:contact@infotech.works"
                className="text-[#b32126]  hover:text-[blue] "
              >
                contact@infotech.works
              </a>
            </p>

            <span>
              📍 Infotech.works, Iris Wing E, Lane 5A, Baner-Balewadi Road,
              Pune, Maharashtra 411045, India
            </span>
          </div>

          <hr className="border-gray-300" />

          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>10. Project Estimates and Proposals</strong>
            </h2>

            <p className="text-gray-700">
              All estimates, proposals, timelines, and pricing shared by
              Infotech.works are provided in good faith and are based on
              available information and initial assumptions at the time of
              issuance. They are <strong>non-binding</strong> and subject to
              change upon deeper technical discovery, requirement changes, or
              third-party dependencies.
            </p>

            <p>
              No quote or proposal constitutes a formal offer unless explicitly
              stated in a signed agreement or Statement of Work (SOW). Final
              pricing, scope, and delivery terms are only confirmed after mutual
              execution of a service contract.
            </p>
          </div>
          <hr className="border-gray-300" />
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>11. Non-Disclosure Agreements (NDAs)</strong>
            </h2>

            <p className="text-gray-700">
              Infotech.works respects client confidentiality and routinely
              enters into{" "}
              <strong>Mutual Non-Disclosure Agreements (MNDAs)</strong> to
              protect sensitive business information. Any confidential data
              shared by either party—whether verbal, written, or electronic—is
              safeguarded under the terms of the applicable NDA.
            </p>

            <p>
              In the absence of a signed NDA, Infotech.works will treat
              commercially sensitive information with reasonable care and
              expects the same courtesy from clients and partners.
            </p>
          </div>

          <hr className="border-gray-300" />
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>12. Use of Case Studies and Testimonials</strong>
            </h2>

            <p className="text-gray-700">
              Infotech.works may showcase anonymized project outcomes or
              performance metrics for educational, marketing, or demonstration
              purposes—unless restricted by explicit NDA clauses or written
              client requests. Client names, logos, or proprietary material will{" "}
              <strong>never</strong> be published without prior written consent.
            </p>
          </div>

          <hr className="border-gray-300" />
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#b32126] uppercase">
              <strong>13. Third-Party Tools, Frameworks & Licensing</strong>
            </h2>
            <p className="text-gray-700">
              Projects delivered by Infotech.works may utilize open-source
              libraries, third-party APIs, SaaS platforms, or licensed software
              as per the requirements. Clients are responsible for reviewing and
              managing compliance with the respective licenses, subscriptions,
              and long-term usage rights unless otherwise stated in the
              agreement.
            </p>
            <p className="text-gray-700">
              {" "}
              Infotech.works provides recommendations and technical due
              diligence but does not accept liability for changes in third-party
              services, pricing, or API availability.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
